<div class="embedded-container h-100">
  <iframe
    *ngIf="embeddedUrl"
    [src]="embeddedUrl | safe"
    allow="camera; clipboard-write; clipboard-read"
    style="border: 0; width: 100%; height: 100%; background-color: transparent !important;"
  ></iframe>
</div>
